import { Router, CanMatchFn, RedirectCommand } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { map, take } from 'rxjs';
import { IsUser } from '../../interfaces/is-user';
import { RouteSegments } from '../../types/route-segments';
import { PlatformService } from '../../services/platform.service';

export const authGuard: CanMatchFn = () => {
	const router: Router = inject(Router);
	const authService: AuthService = inject(AuthService);
	const platformService: PlatformService = inject(PlatformService);

	return authService.user.pipe(
		take(1),
		map((user: IsUser | undefined) => {
			if (user) {
				// User is authenticated
				return true;
			} else {
				// User is not authenticated, redirect when browser
				if (platformService.isBrowser()) {
					return new RedirectCommand(router.parseUrl(RouteSegments.LOGIN));
				}
				return false;
			}
		})
	);
};
